const useMozartColors = () => ({
    greenCS: '#0E773C',
    blueCS: '#17194B',
    yellowCS: '#FFE600',
    white: '#fff',
    redLight: '#d36e6e',
    red: '#d9534f',
    gray: '#ddd',
    grayLight: '#f7f7f7',
    grayDark: '#666',
    green: '#0cff00',
    yellow: '#fff600'
});

export default useMozartColors;
